import CustomSingleSelect from './CustomSingleSelect';

export default CustomSingleSelect;
